const faqSections = document.querySelectorAll( '.block.faq' );

faqSections.forEach( (faqSection) => {
  const showMoreButton = faqSection.querySelector( '.js-show-more-button' );

  if (!showMoreButton) {
    return;
  }
  
  showMoreButton.addEventListener( 'click', (e) => {
    e.preventDefault();

    const button = e.currentTarget;
    const buttonLabel = button.querySelector( '.js-show-more-label' )
    const buttonIcons = button.querySelectorAll( '.button__icon' );
    const faqContainer = button.closest( '.faq__content' );
    const itemsContainer = faqContainer.querySelector( '.faq__items' );
    const targets = itemsContainer.querySelectorAll( '.js-show-more-target' );
    const progress = faqContainer.querySelector( '.js-show-more-progress' );
    const currentAmount = faqContainer.querySelector( '.js-show-more-current-amount' );
    let allItems;
    let shownItems;

    targets.forEach( (target) => {
      target.classList.toggle( 'is-hidden' );
    } );
    buttonIcons.forEach( (icon) => {
      icon.classList.toggle( 'is-hidden' );
    } );

    allItems = itemsContainer.querySelectorAll( '.faq__item' );
    shownItems = itemsContainer.querySelectorAll( '.faq__item:not(.is-hidden)' );

    progress.value = shownItems.length;
    currentAmount.textContent = shownItems.length;

    if (shownItems.length === allItems.length) {
      buttonLabel.textContent = button.dataset.labelShowLess;
    } else {
      buttonLabel.textContent = button.dataset.labelShowMore;
    }
  } );
} );
